<template>
    <v-dialog 
        v-model="handleDialog" 
        width="800" 
        class="text-center"
    >
        <v-card color="#F4FEFB">
            <v-card-title 
                class="text-h4"
            >
                IPアドレスの{{ formTitle }}
            </v-card-title>
            <v-card-text>
                <v-container>
                    <error-message v-model="errorMessage">{{ message }}</error-message>
                    <v-row>
                        <v-col cols="12">
                            <badge-component tile content="必　須" color="red">
                                <label-component>
                                    アクセスを許可するIPアドレス
                                </label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" class="mb-4">
                            <v-text-field 
                                outlined 
                                clearable 
                                v-disabled-icon-focus 
                                v-model="ipAddress" 
                                background-color="white"
                                hint="入力例）192.0.2.123、192.0.2.0/24"
                                persistent-hint
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <badge-component tile content="任　意">
                                <label-component>メモ</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field 
                                outlined 
                                clearable 
                                v-disabled-icon-focus 
                                v-model="note" 
                                background-color="white"
                                maxlength="255"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="justify-center grey lighten-4 pb-6">
                <v-btn 
                    min-width=150
                    class="white--text" 
                    color="blue-grey lighten-1" 
                    large 
                    @click="handleDialog = false"
                >
                    キャンセル
                </v-btn>
                <v-btn 
                    min-width="150px" 
                    class="white--text" 
                    color="red" 
                    large 
                    :disabled="invalid"
                    @click="save"
                >
                    保存
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import InlineErrorMessage from '../../components/common/InlineErrorMessageComponent';
    export default {
        data() {
            return {
                dialogItem: this.item,
                message: null,
                success: false
            };
        },
        components: {
            'error-message': InlineErrorMessage,
        },
        computed: {
            formTitle () {
                return this.dialogItem.id ? '編集' : '追加';
            },
            invalid () {
                return this.dialogItem.ip_address ? false : true;
            },
            errorMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
            handleDialog: {
                get() {
                    return this.dialog;
                },
                set(value) {
                    this.$emit('update:dialog', value);
                }
            },
            id: {
                get() {
                    return this.dialogItem.id;
                },
                set(value) {
                    this.dialogItem.id = value;
                }
            },
            ipAddress: {
                get() {
                    return this.dialogItem.ip_address;
                },
                set(value) {
                    this.dialogItem.ip_address = value;
                }
            },
            note: {
                get() {
                    return this.dialogItem.note;
                },
                set(value) {
                    this.dialogItem.note = value;
                }
            },
        },
        methods: {
            save: function () {
                axios.post(
                    '/documents/ip-address-whitelist/save',
                    {
                        'id': this.id??'',
                        'ip_address': this.ipAddress,
                        'note': this.note
                    }
                ).then(res => {
                    if (res.data.success) {
                        this.$emit("success", res.data.message);
                        this.handleDialog = false;
                    } else {
                        this.message = res.data.message;
                    }
                }).catch(res => {
                    this.success = false;
                    this.message = "処理に失敗しました";
                }).finally(() => {
                });
            }
        },
        props: {
            item: {},
            dialog: Boolean,
        },
    };
</script>

<style scoped>
    .col {
        padding: 0px 12px;
    }
</style>